export default __webpack_public_path__ + "static/media/placeholder.c1bf1ab8.png";